/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import * as React from 'react';
import { compose, lifecycle, withHandlers, withProps, withState } from 'recompose';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { withNotifications } from '@components/hoc/withNotifications';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { change, formValueSelector, reduxForm } from 'redux-form';
import {
  InputField,
  Input,
  DateField,
  Date,
  AutoCompleteField,
  AutoComplete,
  CheckboxField,
  Checkbox
} from '@components/form';
import { iszrIdentificationTypeEnum } from '@modules/events/_eventsEnums';
import {
  iszrLookupPerson,
  aiseoLookup,
  aiseoAifoLookup,
  aiscLookup
} from '@modules/wantedPersons/_wantedPersonsActions';
import { getConfig } from '@components/provider/configuration/_configurationActions';
import { get, isEmpty, merge } from 'lodash';
import { actions as notifyActions } from 'redux-notifications';
import { connect } from 'react-redux';
import { birthNumberToBirthDate } from '@utils/utils';
import { format } from 'date-fns';

const validateData = ({
  firstName,
  lastName,
  birthDate,
  value,
  type,
  includeAiseo,
  includeAisc,
  handleFormErrorMessage
}) => {
  const validPersonalData = firstName && lastName && birthDate;
  const validIdentification = value && type;
  if (!includeAiseo && !includeAisc) {
    // basic iszr
    if (!(validPersonalData || validIdentification)) {
      handleFormErrorMessage('Pro zvolenou lustraci vyplňte doklad totožnosti anebo jméno, příjmení a datum narození');
      return false;
    }
  } else {
    // extended iszr
    if (!validPersonalData) {
      handleFormErrorMessage('Pro zvolenou lustraci vyplňte jméno, příjmení a datum narození');
      return false;
    }
  }
  handleFormErrorMessage(undefined);
  return true;
};

const enhance = compose<any, any>(
  withState('showError', 'handleShowError', false),
  withState('formErrorMessage', 'handleFormErrorMessage', undefined),
  withNotifications({ getConfig }),
  lifecycle<any, {}, {}>({
    async componentDidMount() {
      const { getConfigNotify } = this.props;
      try {
        const config = await getConfigNotify();
        this.setState({ config });
      } catch {
        this.setState({ config: {} });
      }
    }
  }),
  connect<any>(
    state => {
      return {
        includeAisc: formValueSelector('module-iszr-lookup')(state, 'includeAisc'),
        includeAiseo: formValueSelector('module-iszr-lookup')(state, 'includeAiseo')
      };
    },
    dispatch => ({
      changeBirthDate: value => dispatch(change('module-iszr-lookup', 'birthDate', value))
    })
  ),
  withProps(({ config }) => ({
    iszrPhotoEnable: get(config, 'extensions.iszr-photo') === 'true',
    iszrCtiAifo: get(config, 'extensions.iszr-cti-aifo') === 'true'
  })),
  withHandlers({
    onSubmit: ({
      closeItem,
      withPhoto,
      changeFieldValue,
      changePhoto,
      handleLoader,
      incrementCrvLookupsVersion,
      handleShowError,
      handleFormErrorMessage,
      dispatch,
      iszrCtiAifo,
      iszrPhotoEnable
    }) => async formData => {
      handleLoader(true);
      const isValid = validateData({ ...formData, handleFormErrorMessage });

      handleShowError(!isValid);

      if (!isValid) {
        handleLoader(false);
        return;
      }

      const {
        firstName,
        lastName,
        birthDate,
        birthNumber,
        type,
        value,
        includePhoto,
        includeAiseo,
        includeAisc
      } = formData;

      // ISZR api
      const result = await iszrLookupPerson({
        person: {
          firstName,
          lastName,
          birthDate,
          identifications: type && value ? [{ type, value }] : []
        },
        includePhoto
      });
      let resultPerson = result !== null && result.person ? result.person : {};
      const resultPhoto = result !== null && result.photo ? result.photo : undefined;

      let aifo: string | undefined;
      if (result !== null) {
        aifo = iszrPhotoEnable ? result.person.aifo : result.aifo;
      }

      // AISEO api
      if (includeAiseo) {
        if (aifo && iszrCtiAifo) {
          // new AISEO call
          const aiseoAifoResult = await aiseoAifoLookup(aifo);
          // success
          if (aiseoAifoResult !== null) {
            resultPerson = merge(resultPerson, aiseoAifoResult);
          }
          console.log({ aiseoAifoResult });
        } else {
          // old AISEO call
          const aiseoResult = await aiseoLookup({
            firstName,
            lastName,
            birthDate,
            birthNumber
          });
          // success
          if (aiseoResult !== null) {
            resultPerson = merge(resultPerson, aiseoResult);
          }
        }
      }

      // AISC api
      if (includeAisc) {
        const aiscResult = await aiscLookup({
          firstName,
          lastName,
          birthDate,
          birthNumber
        });
        // success
        if (aiscResult !== null) {
          resultPerson = merge(resultPerson, aiscResult);
        }
      }

      // no results
      if (isEmpty(resultPerson)) {
        dispatch(
          notifyActions.notifSend({
            message: 'Žádné výsledky lustrace',
            kind: 'danger',
            dismissAfter: 6000
          })
        );
        handleLoader(false);
        return;
      }

      for (const attribute of Object.keys(resultPerson)) {
        changeFieldValue(attribute, resultPerson[attribute]);
      }

      if (withPhoto && !isEmpty(resultPhoto)) {
        changePhoto(resultPhoto);
      }

      incrementCrvLookupsVersion();
      closeItem();
      handleLoader(false);
    }
  }),
  reduxForm({
    form: 'module-iszr-lookup'
  })
);

const View = ({
  closeItem,
  showError,
  handleSubmit,
  iszrPhotoEnable,
  formErrorMessage,
  includeAisc,
  includeAiseo,
  changeBirthDate
}) => (
  <div style={{ margin: '15px' }}>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <h4>Lustrace ISZR</h4>
        </Row>
        <Row>
          {[{ label: 'Jméno *', name: 'firstName' }, { label: 'Příjmení *', name: 'lastName' }].map(
            ({ label, name }) => (
              <Col md={4} key={name}>
                <InputField component={Input} name={name} label={label} />
              </Col>
            )
          )}
          <Col md={4}>
            <DateField component={Date} name={'birthDate'} label={'Datum narození *'} />
          </Col>
          <Col md={4}>
            <InputField
              component={Input}
              name={'birthNumber'}
              label={'Rodné číslo'}
              onBlur={e => {
                if (e) {
                  const birthNumber = e.target.value;
                  const birthDate = birthNumberToBirthDate(birthNumber);
                  if (birthDate) {
                    changeBirthDate(format(birthDate, 'YYYY-MM-DD'));
                  }
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <AutoCompleteField
              component={AutoComplete}
              name="type"
              label={includeAisc || includeAiseo ? 'Typ dokladu' : 'Typ dokladu *'}
              items={iszrIdentificationTypeEnum}
              labelFunction={({ label }) => label}
              valueFunction={({ id }) => id}
              fullWidth={true}
            />
          </Col>
          <Col md={6}>
            <InputField
              component={Input}
              name="value"
              label={includeAisc || includeAiseo ? 'Číslo dokladu' : 'Číslo dokladu *'}
            />
          </Col>
        </Row>

        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          {iszrPhotoEnable && (
            <Col md={3}>
              <CheckboxField component={Checkbox} name="includePhoto" label="Stáhnout fotku" />
            </Col>
          )}
          <Col md={4}>
            <CheckboxField component={Checkbox} name="includeAiseo" label="Lustrace registru obyvatel" />
          </Col>
          <Col md={4}>
            <CheckboxField component={Checkbox} name="includeAisc" label="Lustrace registru cizinců" />
          </Col>
        </Row>

        {showError && (
          <Row>
            <h5 style={{ color: 'red' }}>{formErrorMessage}</h5>
          </Row>
        )}
      </Grid>
      <Button label={'Lustrovat'} type="submit" primary={true} style={{ margin: '15px' }} />
      <Button label={'Zavřít'} onClick={closeItem} style={{ marginTop: '15px' }} />
    </form>
  </div>
);

export const IszrLookupsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/components/person/IszrLookupsForm.tsx